export const events = {
  "error.password.required": "Поле Пароль обязательное",
  "error.password.min": "Пароль должен содержать не менее 6 символов",
  "error.password.max": "Пароль должен содержать не больше 28 символов",
  "error.password.matchUpper":
    "Пароль должен содержать хотя бы одну заглавную букву",
  "error.password.matchLower":
    "Пароль должен содержать хотя бы одну строчную букву",
  "error.password.number": "Пароль должен содержать хотя бы одну цифру",
  "error.password.symbol":
    "Пароль должен содержать хотя бы один специальный символ",
  "error.email.format": "Неверный формат почты",
  "error.email.required": "Поле Email обязательное",
  "error.description.required": "Описание обязательное поле",
  "error.nikname.required": "Никнейм обязательное поле",
  "error.terms.required": "Вы должны принять условия",
  "error.code.required": "Введите код подтверждения",
  "error.code.min": "Код должен содержать не менее 2 символов",
  "error.code.max": "Код должен содержать не больше 8 символов",
  "error.contact.invalid": "Неверный формат",
  "error.name.required": "Название обязательное поле",
  "error.date.required": "Дата обязательное поле",
  "error.results.required": "Исход обязательное поле",
  "error.results.min": "У события должно быть ровно два исхода.",
  "error.promoCode.required": "Промокод обязательное поле",
  "error.password.match": "Пароли должны совпадать",
  "error.date.invalid": "Не валидная дата",
  "error.date.format": "Формат должен быть XX.XX.XXXX",
};
